/* eslint-disable internal-rules/agg-product-areas */
import { operators as o } from '@pendo/aggregations';
import { basicPipeline, INCLUDE_USERS_FOR_VOCITEMS } from '@/voc/helpers/aggs.helper';
import { PRODUCT_AREAS } from '@utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};

export default {
    name: 'VocItem',
    productArea: VOC,
    responseFormat: 'row',
    build: ({
        vocItemId,
        appId = 'expandAppIds("*")',
        type = 'idea',
        segmentId = null,
        allTime = true,
        timeSeriesConfig = null,
        shouldFilterVotes = true,
        revenueField = null,
        accountDisplayName = null,
        visitorDisplayName = null,
        expandInsights = false,
    }) => {
        const agg = basicPipeline({
            type,
            voteSegmentId: segmentId,
            allTime,
            timeSeries: timeSeriesConfig,
            shouldFilterVotes,
            revenueField,
            accountDisplayName,
            visitorDisplayName,
            expandInsights,
            vocItemId,
        });

        agg.fork.push(...INCLUDE_USERS_FOR_VOCITEMS({ visitorDisplayName }));

        const pipeline = o.pipeline(
            o.sources.vocItems({
                vocItemId,
                appId,
                type,
            }),
            ...[...agg.pipeline, ...[o.fork(...agg.fork), o.join('id')], agg.select],
        );

        return pipeline;
    },
};
